import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';
import { Cpu } from '@phosphor-icons/react';

const About = ({ content }) => {
    const ref = useRef(null);
    const isInView = useInView(ref, { once: true, margin: '-100px' });

    const aboutIntro = content?.about_intro?.content || 'Spindrift Engineering Limited is a Scottish company dedicated to developing products for use in the marine and engineering industries.';
    const aboutSoftware = content?.about_software?.content || 'Under our software division, Spindrift Engineering Software, we are developing a range of applications designed specifically for marine and engineering professionals.';
    const mission = content?.company_mission?.content || 'To deliver practical, reliable engineering and software solutions that address real-world challenges in the marine and industrial sectors.';

    return (
        <section 
            id="about" 
            className="py-24 sm:py-32 bg-background-base"
            data-testid="about-section"
            ref={ref}
        >
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                {/* Section Header */}
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={isInView ? { opacity: 1, y: 0 } : {}}
                    transition={{ duration: 0.6 }}
                    className="mb-12 text-center"
                >
                    <span className="text-sm uppercase tracking-[0.2em] font-bold text-secondary">
                        About Us
                    </span>
                    <h2 className="text-3xl sm:text-4xl font-medium tracking-tight text-text-primary mt-4">
                        Engineering Excellence from Scotland
                    </h2>
                </motion.div>

                {/* Content */}
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    animate={isInView ? { opacity: 1, y: 0 } : {}}
                    transition={{ duration: 0.6, delay: 0.2 }}
                    className="space-y-6"
                >
                    <p 
                        className="text-lg text-text-secondary leading-relaxed"
                        data-testid="about-intro"
                    >
                        {aboutIntro}
                    </p>
                    <p 
                        className="text-base text-text-secondary leading-relaxed"
                        data-testid="about-software"
                    >
                        {aboutSoftware}
                    </p>

                    {/* Mission */}
                    <div className="p-6 bg-background-surface border border-border-subtle rounded-sm mt-8">
                        <h3 className="text-lg font-medium text-text-primary mb-3 flex items-center gap-2">
                            <Cpu size={20} weight="duotone" className="text-primary" />
                            Our Mission
                        </h3>
                        <p 
                            className="text-text-secondary"
                            data-testid="about-mission"
                        >
                            {mission}
                        </p>
                    </div>
                </motion.div>
            </div>
        </section>
    );
};

export default About;
